module.exports = __webpack_public_path__ + "static/media/cloudplus.68d69509.png";